import {
  _measureTextWidth,
  _getPxStyle
} from './utils';

/**
 * 根据内容最长一项，自动适应宽度的 el-select
 * @example <el-select v-select-auto-width ...></el-select>
 */
export default {
  inserted (el, binding, vnode) {
    let items = el.querySelectorAll('.el-select-dropdown__item');
    if (!items) return;
    el.style.opacity = 0.01;
    let ipt = el.querySelector('.el-input');
    ipt.click();
    const vm = vnode.context;
    vm.$nextTick(() => {
      const maxWidth = Array.prototype.map.call(
        items,
        liEle => liEle.querySelector('span')
      ).reduce((max, spanEle) => {
        const w = _measureTextWidth(spanEle.innerText);
        return Math.max(max, w);
      }, 0);

      let realIpt = ipt.querySelector('input'); 
      let padL = _getPxStyle(realIpt, 'paddingLeft');
      let padR = _getPxStyle(realIpt, 'paddingRight');
      padL = padL === null ? 10 : padL;
      padR = padR === null ? 35 : padR;
      const w = maxWidth + padL + padR + 5;
      el.style.width = `${w}px`;
      console.log('[v-select-auto-width]', w);
      if (!binding.modifiers.nomargin) {
        el.style.marginRight = '10px';
      }
      ipt.style.marginRight = '0';

      el.style.opacity = 1;
      ipt.click();
      items = null;
      realIpt = null;
      ipt = null;

      let tmpIpt = document.createElement('input');
      tmpIpt.type = 'text';
      tmpIpt.style.height = '0';
      tmpIpt.style.opacity = '0';
      document.body.appendChild(tmpIpt);
      tmpIpt.focus();
      document.body.removeChild(tmpIpt);
      tmpIpt = null;
    });
  }
};



// WEBPACK FOOTER //
// ./src/directives/selectAutoWidth.js